<template>
  <div class="consultingServicePage">
    <v-topBar :yellowPageColumn='yellowPageColumn'
              :productAndSolutionColumn='productAndSolutionColumn'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-topBar>
    <v-header class="hidden-xs hidden-sm"
              :navigationColumnInfos='navigationColumnInfos'
              :webConfigInfo='webConfigInfo'
              :hitSearchUrl='hitSearchUrl'
              :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl">
    </v-header>
    <el-row>
      <el-col :span="24">
        <div class="bgImg" style="cursor: pointer;"></div>
        <!--<img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E5%BE%81%E4%BF%A1banner1.jpg" width="100%">-->
        <div class="partTwo">
          <v-publiceTit :titleObj='titleObj' style="margin-bottom: 30px;"></v-publiceTit>
          <div class="row">
            <ul class="clearfix" v-if="credit.length == 2">
              <li class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
                  v-for="(item, index) in credit" :key="index">
                <el-card :body-style="{ padding: '0'}">
                  <div class="cardImg" :style="{background: 'url(' + item.backgroundUrl + ') no-repeat bottom right'}">
                    <img :src="item.serviceIcon" class="imgsrc"/>
                    <div style="margin: 20px 0;">
                      <h4 style="-webkit-box-orient: vertical;">{{item.serviceName}}</h4>
                      <p class="desc">{{item.serviceIntroduce}}</p>
                    </div>
                    <el-button type="warning" @click="see(item.url)" style="cursor: pointer; background-color: #F2AA3C;">
                      立即购买
                    </el-button>
                  </div>
                </el-card>
              </li>
            </ul>
            <ul class="clearfix" v-else>
              <li class="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                  v-for="(item, index) in credit" :key="index" >
                <el-card :body-style="{ padding: '0'}">
                  <div class="cardImg" :style="{background: 'url(' + item.backgroundUrl + ') no-repeat bottom right'}">
                    <img :src="item.serviceIcon" class="imgsrc"/>
                    <div style="margin: 22px 0;">
                      <h4 style="-webkit-box-orient: vertical;">{{item.serviceName}}</h4>
                      <p class="desc">{{item.serviceIntroduce}}</p>
                    </div>
                    <el-button @click="see(item.url)" style="cursor: pointer; background-color: #F2AA3C;">
                      立即购买
                    </el-button>
                  </div>
                </el-card>
              </li>
            </ul>
          </div>
        </div>
        <div class="partThree">
          <v-publiceTit :titleObj='titleObjrisk' class="titleObjrisk"></v-publiceTit>
          <div class="row2">
            <ul class="clearfix">
              <li class="col-lg-4 col-md-4 col-sm-4 col-xs-4" style="padding: 0">
                <div class="imgleft imgcommon imgprivate" >
                  <p>明晰企业间股权关系</p>
                  <p>一键排除多家供应商串围标风险</p>
                </div>
              </li>
              <li class="col-lg-8 col-md-8 col-sm-8 col-xs-8" style="padding: 0">
                <div class="imgrightop imgcommon imgprivate2 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p>深度挖掘企业信息</p>
                  <p>及时了解风险，有效规避风险</p>
                </div>
                <div class="imgrightbot imgcommon imgprivate2 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <p>实时监控企业动态</p>
                  <p>自动判别新闻事件，缩小阅读量</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>
    <v-footer :webConfigInfo='webConfigInfo' :footerColumnInfos='footerColumnInfos'></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>

<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'
import publiceTit from '@/components/publiceTit'
import {customActivityDetail} from '@/assets/js/sensors'

export default {
  name: '',
  data () {
    return {
      yellowPageColumn: {},
      productAndSolutionColumn: {},
      hitSearchUrl: '',
      enterpriseResourceBaseUrl: '',
      navigationColumnInfos: [],
      webConfigInfo: {},
      footerColumnInfos: [],
      credit: [],
      titleObj: {name: '“安心采”服务', eng: 'PROCUREMENT SERVICE'},
      titleObjrisk: {name: '“安心采”服务的核心价值', eng: 'CORE VALUE'}
    }
  },
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-footer': footer,
    'v-backToTop': backToTop,
    'v-publiceTit': publiceTit
  },
  created () {
    this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
    }).then((res) => {
      this.data = res.data;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
    }).catch()
  },
  mounted () {
    this.getProductInfo()

    // 埋点
    try {
      customActivityDetail({
        page_title: "安心采"
      })
    } catch (e) {console.log(e)}
  },
  methods: {
    getProductInfo () {
      this.$axios.post('/onelink.mdata.main.api/credit/findCreditProductInfo', {
      }).then((res) => {
        if (res.data.success === true) {
          this.credit = res.data.serviceItems
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    see (e) {
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
        this.$alert('<p>请在PC端点击立即购买\n</p>', '', {
          dangerouslyUseHTMLString: true,
          customClass:'mobileText',
          center: true
        })
      }else{
        if(this.getToken('isLogin') == ''){
          this.$router.push({path:'/login',query:{redirectURL:'/creditReport'}});
        }else if(this.getToken('userTag') == '10'){
          this.$alert('<p>您是供应商身份，不能购买该服务。</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
          return false;
        }else{
          window.location.href = e;
        }
      }

    }
  }
}
</script>

<style lang="stylus" scoped>
  .bgImg {
    width: 100%;
    height: 262px;
    position: relative;
    background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/%E5%BE%81%E4%BF%A1banner1.jpg') no-repeat center;
    background-size: 100%;
  }
  .partTwo,.partThree{
    text-align: center;
    padding: 50px 0;
  }
  .partTwo {
    font-family: PingFangSC-Regular;
  }
  .el-card {
    .cardImg {
      padding: 34px 10px 40px;
      background-size: 60%!important;
    }
    img {
      width: 82px;
      height: 82px;
    }
    h4 {
      font-family: PingFangSC-Medium;
      font-size: 30px;
      color: #303133;
      line-height: 30px;
    }
    .desc {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #606266;
      text-align: center;
      line-height: 24px;
      height: 48px;
      margin-top: 15px;
    }
    .el-button {
      border-radius: 4px;
      width: 160px;
      height: 48px;
      padding: 0;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      line-height: 18px;
    }
  }
  .partThree {
    background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/riskcontrol.jpg') no-repeat center top;
    background-size: cover;
    .imgleft {
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/riskstock.jpg');
      max-width: 420px;
      height: 560px;
    }
    .imgrightop {
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/riskinfo.jpg');
    }
    .imgrightbot {
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/risktime.jpg');
    }
    .imgrightop, .imgrightbot {
      max-width: 780px;
      height: 280px;
      text-align: left;
      padding-left: 64px;
    }
    .imgcommon {
      p:nth-child(1) {
        font-family: PingFangSC-Medium;
        font-size: 30px;
        color: #FFFFFF;
        line-height: 30px;
      }
      p:nth-child(2) {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 32px;
      }
    }
    .imgprivate {
      p:nth-child(1) {
        padding-top: 120px;
      }
      p:nth-child(2) {
        padding-top: 30px;
      }
    }
    .imgprivate2 {
      p:nth-child(1) {
        padding-top: 64px;
      }
      p:nth-child(2) {
        padding-top: 12px;
      }
    }
  }
  .row, .row2 {
    max-width: 1200px;
    margin: auto;
    ul {
      padding: 0 12px;
    }
    >li {
       max-height: 420px;
     }
  }
  @media screen and (max-width: 768px) {
    .bgImg {
      height: 120px;
      background-size: cover;
    }
    .el-card {
      .cardImg {
        padding: 28px 10px 34px;
      }
      h4 {
        font-size: 20px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      img {
        width: 55px;
        height: 55px;
      }
      .desc{
        font-size: 12px;
        line-height: 24px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .el-button {
        width: 100px;
        height: 30px;
        font-size: 14px;
        line-height: 14px;
      }
    }
    .row {
      overflow: auto;
      ul {
        width: 512px;
      }
      >li {
         width: 160px;
         height: 280px;
         margin: 0 8px;
         padding: 0;
       }
     }
    .row2 {
      li:first-child,.imgleft {
         width: 40%;
         height: 186px;
         background-size: cover;
         padding: 0 20px;
       }
      .imgleft {
        width: 100%;
      }
      li:last-child,.imgrightop, .imgrightbot {
        width: 60%;
        height: 93px;
        background-size: cover;
        padding-left: 30px;
      }
      .imgrightop, .imgrightbot{
        width: 100%;
      }
     .imgcommon {
        p:nth-child(1) {
          font-size: 16px;
          line-height: 24px;
        }
        p:nth-child(2) {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .imgprivate {
        p:nth-child(1) {
          padding-top: 31px;
        }
        p:nth-child(2) {
          padding-top: 10px;
        }
      }
    .imgprivate2 {
      p:nth-child(1) {
        padding-top: 16px;
      }
      p:nth-child(2) {
        padding-top: 0;
      }
      }
    }
  }
</style>
<style lang="stylus">
    .titleObjrisk {
      margin-bottom: 30px;
    }
    .titleObjrisk .title{
      .titleBg , .titleCon{
        color: #fff;
      }
      .line{
        background: #fff;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/creditReport/index.vue